import { MonitorBase } from './_MonitorBase';

export class MonitorFPS extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'fps', ...config });

    this._minFPS = -1;
    this._maxFPS = -1;

    this.game.events.on(Phaser.Core.Events.POST_RENDER, this.updateMonitor, this);
    this.updateMonitor();
  }

  shutdown() {
    this.game.events.off(Phaser.Core.Events.POST_RENDER, this.updateMonitor, this);
  }

  updateMonitor() {
    this.setValue(Math.round(this.game.loop.actualFps));
    this._minFPS =
      this._minFPS >= 0
        ? Math.min(this.game.loop.actualFps, this._minFPS)
        : this.game.loop.actualFps;
    this._maxFPS =
      this._maxFPS >= 0
        ? Math.max(this.game.loop.actualFps, this._maxFPS)
        : this.game.loop.actualFps;
  }

  getLog() {
    let str = '';
    str += `FPS Current\t: ${Math.round(this.game.loop.actualFps)}`;
    str += `\nFPS Min\t: ${Math.round(this._minFPS)}`;
    str += `\nFPS Max\t: ${Math.round(this._maxFPS)}`;
    return str;
  }
}
